export const Table_Array = [
  { Name: "Name", Field: "School_Name" },
  { Name: "Country", Field: "School_Country" },
  { Name: "PostCode", Field: "School_PostCode" },
  { Name: "Region", Field: "School_Region" },
  { Name: "PD", Field: "School_PD" },
  { Name: "Date Assigned", Field: "School_DateAssigned" },
  { Name: "Type", Field: "School_Type" },
  { Name: "Boarding", Field: "School_Boarding" },
  { Name: "Website", Field: "School_Website" },
  { Name: "Capacity", Field: "School_Capacity" },
  { Name: "PS", Field: "School_PS" },
  { Name: "Dukes", Field: "School_Dukes" },
  { Name: "Discount", Field: "School_PS_Code" },
];
